import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import {
  DataGrid,
  gridClasses,
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import axios from "axios";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import DeleteIcon from '@mui/icons-material/DeleteOutlineOutlined';

const DraftTable = () => {
  const [draft, setDraft] = useState();
  const navigate = useNavigate();
  const storedUser = JSON.parse(localStorage.getItem("user"));

  const getTenders = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/draft/get-all?username=${storedUser.username}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setDraft(res.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getTenders();
  }, []);

  const handleCheck = (tenderId) => {
    navigate(`/dashboard/create-tender/draft/${tenderId}`);
  };

  const handleDelete = async (id) => {
    try {
        await axios.delete(
            `${process.env.REACT_APP_BACKEND_URL}/draft?draftTenderId=${id}`,
            { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
          );
          getTenders();
    } catch (error) {
        console.log(error)
    }
  }

  const columns = [
    // {
    //   field: "draftTenderId",
    //   headerName: "ID",
    //   width: 180,
    //   headerAlign: "center",
    // },
     // { field: "tenderId", headerName: "Tender ID", width: 200,headerAlign: "center", },
     {
        field: "title",
        headerName: "Title",
        flex: 1,
        renderCell: (params) => (
          <span
            className="table-title"
            onClick={() => handleCheck(params.row.draftTenderId)}
          >
            {params.row.title}
          </span>
        ),
      },
      {
        field: "type",
        headerName: "Tender Type",
        flex: 1,
        renderCell: (params) =>
          params.row.type
            ? params.row.type.charAt(0).toUpperCase() +
              params.row.type.slice(1).toLowerCase()
            : "",
      },
      {
        field: "tenderPublishDate",
        headerName: "Tender Publish Date",
        flex: 1,
      },
      {
        field: "bidSubmissionEndDate",
        headerName: "Bid Close Date",
        flex: 1,
      },
    //   {
    //     field: "status",
    //     headerName: "Tender Status",
    //     flex: 1,
    //     renderCell: (params) => (
    //       <span
    //         style={{
    //           background: "#FFCD82",
    //           borderRadius: "10px",
    //           padding: 10,
    //         }}
    //       >
    //         {params.row.status
    //           ? params.row.status.charAt(0).toUpperCase() +
    //             params.row.status.slice(1).toLowerCase()
    //           : ""}
    //       </span>
    //     ),
    //   },
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      renderCell: (params) => (
          <Button
          sx={{padding: '0 !important', minWidth: '0px !important'}}
            onClick={() => handleDelete(params.row.draftTenderId)}
            color="#c7c7c7"
          >
            <DeleteIcon />
          </Button>
      ),
    },
  ];

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}/${month}/${year}`;
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "";
    const [date, time] = dateString.split("T");
    const [year, month, day] = date.split("-"); 
    return `${day}/${month}/${year} ${time}`;
  };

  const draftRows =
    draft &&
    draft.map((tender) => ({
      ...tender,
      tenderPublishDate: formatDate(tender.tenderPublishDate),
      bidSubmissionStartDate: formatDateTime(tender.bidSubmissionStartDate),
        bidSubmissionEndDate: formatDateTime(tender.bidSubmissionEndDate),
    }));

  return (
    <Box sx={{ background: "#fff" }}>
      <DataGrid
              rows={draftRows}
              columns={columns}
              //   loading={isLoading}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 10,
                  },
                },
              }}
              pageSizeOptions={[10]}
              disableRowSelectionOnClick
              disableColumnSelector
              disableDensitySelector
              disableColumnMenu
              disableColumnResize
              slots={{ toolbar: CustomToolbar }}
              getRowId={(row) => row.draftTenderId}
              getRowClassName={(params) =>
                params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
              }
              sx={{
                border: "none",
                fontFamily: "Inter !important",
      
                "& .MuiDataGrid-columnHeaderTitle": {
                  fontWeight: "700 !important",
                },
                "& .MuiDataGrid-columnHeaders": {
                  background: "none !important",
                  color: "black",
                  fontSize: "14px",
                  borderRadius: "10px",
                },
                "& .MuiDataGrid-row:hover": {
                  backgroundColor: "#fff",
                },
                "& .MuiDataGrid-cell": {
                  fontSize: "13px",
                  border: "none",
                },
                "& .MuiDataGrid-columnSeparator": {
                  display: "none",
                },
                "& .css-1ccsd5i-MuiButtonBase-root-MuiButton-root": {
                  color: "#000 !important",
                  border: "1px solid #B0B0B0",
                  borderRadius: "12px",
                  padding: 1,
                },
                "& .MuiInputBase-root-MuiInput-root::after": {
                  borderBottom: "none !important",
                },
                "& .MuiInputBase-root-MuiInput-root": {
                  borderBottom: "none !important",
                },
                [`& .${gridClasses.row}.even`]: {
                  backgroundColor: "#EAF4FF",
                  // '&:hover': {
                  //   backgroundColor: "#f6f6f6",
                  // },
                },
              }}
            />
    </Box>
  );
};

export default DraftTable;

function CustomToolbar() {
    return (
      <GridToolbarContainer sx={{ display: "flex", justifyContent: "end" }}>
        <GridToolbarQuickFilter
          style={{
            border: "1px solid var(--Neutral-300, #B0B0B0)",
            borderRadius: "12px",
            padding: 3,
          }}
        />
        {/* <GridToolbarFilterButton /> */}
      </GridToolbarContainer>
    );
  }
